import { Component, OnInit } from "@angular/core";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { MessageService, ConfirmationService } from "primeng/api";
import { AuthService } from "common/services/auth.service";
import { IUser } from "app/shared/Domains/IUser";
import { IRole } from "app/shared/Domains/role";
import { ISubscriptionFee } from "app/services/models/subscriptionFee";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-trainer-dashboard",
    templateUrl: "./trainer-dashboard.component.html",
    styleUrls: ["./trainer-dashboard.component.css"],
})
export class TrainerDashboardComponent implements OnInit {
    loading: boolean;
    user: IUser;
    role: IRole;
    trainer: IUser;
    trainingSessions: any[];
    trainingSessionsFiltered: any[];
    allTrainingSessions: any[];
    allSubscriptions: any[];
    allSubscriptionsFee: any[];
    customers:any[];
    subscribers:any[];
    trainingSessionsDialog: boolean=false;
    sessionsDialog: boolean = false;
    sessionId: string;
    presentClicked: boolean;
    rescheduleClicked: boolean;
    totalTrainerShare = 0;
    trainerAllSubscriptionsFee: ISubscriptionFee[];
    totalTrainerExpanses = 0;
    trainerExpanses = [];
    totalTrainerBorrowed = 0;
    trainerBorrowing = [];
    classSessionsDialog: boolean = false;
    members: any[];
      yearOptions: any[] = [];
      monthOptions: any[] = [];
      monthValue: string;
      yearValue: string;
    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private ConfirmationService: ConfirmationService,
    ) {
    }

    ngOnInit() {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 5;
        const endYear = currentYear;
        this.yearOptions = [];
        for (let year = startYear; year <= endYear; year++) {
            this.yearOptions.push({ label: year.toString(), value: year.toString() });
        }
        this.monthOptions = [
            { label: "January", value: '1' },
            { label: "February", value: '2' },
            { label: "March", value: '3' },
            { label: "April", value: '4' },
            { label: "May", value: '5' },
            { label: "June", value: '6' },
            { label: "July", value: '7' },
            { label: "August", value: '8' },
            { label: "September", value: '9' },
            { label: "October", value: '10' },
            { label: "November", value: '11' },
            { label: "December", value: '12' }
        ];

        this.loading = false;
        this.trainer = new IUser;
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        this.getUser();
        this.getTodaysSessions();
        this.getAllSession();
        this.getAllSubscriptions();
        this.breadcrumbService.setItems([
            { label: 'Trainer Dashboard', routerLink: '/trainer-dashboard' },
        ]);
        const dateNow = new Date();
        this.monthValue = (dateNow.getMonth() + 1).toString();
        this.yearValue = currentYear.toString();
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("TrainerDashboardComponent", label);
      }
      onMonthOrYearChange(): void {
        this.getTrainerSubscriptionsFees();
        this.getTrainerBorrowing();
        this.getTrainerExpanses();
        this.getCustomers();
    }
    getUser(){
        this.allTrainingSessions = [];
        this.loading = true;
        let url;
        url = `users/${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res) {
                        this.trainer = res;
                        this.getTrainerSubscriptionsFees();
                        this.getTrainerExpanses();
                        this.getTrainerBorrowing();
                    } else {
                        this.trainer = new IUser;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getTrainerSubscriptionsFees() {
        this.loading = true;
        const url = `subscriptionFee/${this.user._id}/allFeeByTrainer?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
            (res) => {
                if (res) {
                    this.trainerAllSubscriptionsFee = res.response;
                    let total = 0;
                    this.trainerAllSubscriptionsFee.forEach(fee => {
                        const trainerPackages = this.trainer.fees.filter(t => t._id === fee.trainerPackageId)[0];
                        const trainerShare = 100 - trainerPackages.gymSharePercentage;
                        const totalFee = parseInt(fee.pay) - parseInt(fee.discount);
                        total += ((totalFee * trainerShare) / 100);
                    });
                    this.totalTrainerShare = total;
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                console.log(error);
            }
        );
    }

    getTrainerExpanses() {
        this.loading = true;
        const url = `pettyExpense/${this.user._id}/allExpansesOfTrainer?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
            // this.appServiceManager.get("pettyExpense/" + this.user._id + "/allExpansesOfTrainer").subscribe(
            (res) => {
                if (res) {
                    this.trainerExpanses = res.response;
                    this.getTotalExpanses();
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                console.log(error);
            }
        );
    }
    getTrainerBorrowing() {
        this.loading = true;
        const url = `pettyExpense/${this.user._id}/allBorrowingOfTrainer?month=${this.monthValue}&year=${this.yearValue}`;
        this.appServiceManager.get(url).subscribe(
          (res) => {
            if (res) {
              this.trainerBorrowing = res.response;
              this.getTotalBorrowing();
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      }

    getTotalExpanses() {
        if(this.trainerExpanses.length == 0) {
            this.totalTrainerExpanses = 0;
            return;
        }
        this.trainerExpanses.forEach(e => {
            this.totalTrainerExpanses += parseInt(e.amount);
            });
    }
    getTotalBorrowing() {
        this.totalTrainerBorrowed = 0; // Reset the total before summing up
        if(this.trainerBorrowing.length == 0) {
          this.totalTrainerBorrowed = 0;
          return;
        }
        this.trainerBorrowing.forEach(e => {
          this.totalTrainerBorrowed += parseInt(e.amount);
        });
      }
    getAllSession(){
        this.allTrainingSessions = [];
        this.loading = true;
        let url;
        url = `trainingSessions/company/${this.user.company}/branch/${this.user.branch}/all?trainerId=${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.allTrainingSessions = res;
                    } else {
                        this.allTrainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getAllSubscriptions(){
        this.allSubscriptions = [];
        this.loading = true;
        let url;
        url = `subscriptions/${this.user._id}/allSubscriptionsOfTrainer`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.response.length > 0) {
                        this.allSubscriptions = res.response;
                        this.getAllSubscriptionsFee()
                    } else {
                        this.allSubscriptions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getAllSubscriptionsFee(){
        this.allSubscriptionsFee = [];
        this.loading = true;
        let url;
        url = `subscriptionFee/${this.user._id}/allFeeByTrainer`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.response.length > 0) {
                        this.allSubscriptionsFee = res.response;
                        this.getCustomers();
                    } else {
                        this.allSubscriptionsFee = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getTodaysSessions(){
        this.trainingSessions = [];
        this.loading = true;
        let url;
        url = `trainingSessions/company/${this.user.company}/branch/${this.user.branch}/today?trainerId=${this.user._id}`;
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.trainingSessions = res;
                        this.trainingSessionsFiltered=this.trainingSessions.filter(session=>{
                            return session.trainingType != "classTraining"
                        })
                    } else {
                        this.trainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    changeAttendedStatus(member) {
        member.attendedStatus = member.attendedStatus === 'ATTENDED' ? 'UNMARKED' : 'ATTENDED';
    }
    openClassAttendanceDialog(classSession){
        let todayDate = new Date();
        this.members = this.trainingSessions
                .filter(session => {
                    const sessionStartDate = new Date(session.startDate);
                    const sessionStartDateOnly = new Date(sessionStartDate.getFullYear(), sessionStartDate.getMonth(), sessionStartDate.getDate());
                    const todayDateOnly = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
                    return session.trainerPackageId === classSession.trainerPackageId &&
                        sessionStartDateOnly.getTime() === todayDateOnly.getTime();
                })
                .map(session => {
                    return { id: session._id, name: session.subscriberName, attendedStatus: session.status };
                });
            this.members = this.members.filter(member => member.name !== undefined)
        this.classSessionsDialog = true;
    }
    markClassAttendance(){
        for(let member of this.members){
            if (member.attendedStatus === "UNMARKED") {
                member.attendedStatus = "NO–SHOW";
            }
        }
        const url = `trainingSessions/markClassTrainingAttendance`;
        const body = { members: this.members};
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            this.classSessionsDialog = false;
            this.getTodaysSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }
    hideModal() {
        this.classSessionsDialog = false;

    }
    getCustomers(){
        this.customers = []
        this.subscribers=[];
        let customersMap = {};
        this.allSubscriptions.forEach(subscription => {
            if (!customersMap[subscription.subscriberId]) {
                customersMap[subscription.subscriberId] = {
                    subscriberId: subscription.subscriberId,
                    trainerPackageId:subscription.trainerPackageId,
                    totalSessions: 0,
                    totalSubscriptions: 0
                };
            }
            customersMap[subscription.subscriberId].totalSessions += subscription.numberOfSessions;
            customersMap[subscription.subscriberId].totalSubscriptions += 1;
        });
        this.customers = Object.values(customersMap);
        let subscribersMap = {};
        this.allSubscriptionsFee.forEach(fee => {
            // Assuming `feeDate` is the date field in `fee`
            const feeDate = new Date(fee.date); // Replace `date` with the actual date field in `fee`
            if (
                feeDate.getMonth() + 1 === parseInt(this.monthValue) &&
                feeDate.getFullYear() === parseInt(this.yearValue)
            ) {
                if (!subscribersMap[fee.subscriberId]) {
                    subscribersMap[fee.subscriberId] = {
                        subscriberId: fee.subscriberId,
                        subscriberName: fee.subscriberName,
                        subscriberMembership: fee.subscriberMembership,
                        totalPay: 0
                    };
                }
                subscribersMap[fee.subscriberId].totalPay += (parseInt(fee.pay) - parseInt(fee.discount));
            }
        });

        this.subscribers = Object.values(subscribersMap);
        this.customers = this.subscribers;
        let combinedData: {
            subscriberId: string;
            trainerPackageId?: string;
            totalSessions?: number;
            totalSubscriptions?: number;
            subscriberName?: string;
            subscriberMembership?: string;
            totalPay?: number;
            totalAttendedSessions?: number;
            totalMissedSessions?: number;
        }[]
        combinedData = this.customers.map(customer => {
            let matchingSubscriber = this.subscribers.find(subscriber => subscriber.subscriberId === customer.subscriberId);
            if (matchingSubscriber) {
                return {
                    subscriberId: customer.subscriberId,
                    trainerPackageId:customer.trainerPackageId,
                    totalSessions: customer.totalSessions,
                    totalSubscriptions: customer.totalSubscriptions,
                    subscriberName: matchingSubscriber.subscriberName,
                    subscriberMembership: matchingSubscriber.subscriberMembership,
                    totalPay: matchingSubscriber.totalPay
                };
            } else {
                return {
                    subscriberId: customer.subscriberId,
                    totalSessions: customer.totalSessions,
                    totalSubscriptions: customer.totalSubscriptions
                };
            }
        });


        combinedData.forEach(subscriber => {
            let attendedSessions = 0;
            let missedSessions = 0;

            this.allTrainingSessions.forEach(session => {
                if (session.subscriberId === subscriber.subscriberId) {
                    if (session.status == "ATTENDED") {
                        attendedSessions++;
                    } else if (session.status == "NO–SHOW") {
                        missedSessions++;
                    }
                }
            });

            let currentSubscriber = combinedData.find(sub => sub.subscriberId === subscriber.subscriberId);
            if (currentSubscriber) {
                currentSubscriber.totalAttendedSessions = attendedSessions;
                currentSubscriber.totalMissedSessions = missedSessions;
            }
        });
        this.customers=[];
        this.customers=combinedData;
        this.customers.forEach(customer=> {
            let trainerFee = this.trainer.fees.find(fee => fee._id == customer.trainerPackageId)
            let trainerSharePerct = 100 - trainerFee.gymSharePercentage;
            customer.trainershare = parseInt(customer.totalPay) * trainerSharePerct / 100;
        });
    }
    markPresent(session){
        this.sessionsDialog=true;
        this.sessionId = session._id;
        this.presentClicked=true;
        this.rescheduleClicked=false;
    }
    reschedule(session){
        this.sessionsDialog=true;
        this.sessionId = session._id;
        this.presentClicked=false;
        this.rescheduleClicked=true;
    }
    markAbsent(session) {
        this.ConfirmationService.confirm({
          message: 'Are you sure you want to mark this session as absent?',
          accept: () => {
            const url = `trainingSessions/markAbsent/${session._id}`;
            const body = {  status: "NO–SHOW" };
            this.appServiceManager.put(url, body).subscribe((res: any) => {
              this.trainingSessionsDialog = false;
              this.getTodaysSessions();
            }, error => {
              console.error('Attendance failed', error);
            });
          }
        });
      }
    closeTrainingSessionsDialog() {
        this.getTodaysSessions();
        this.sessionsDialog = false;
    }

    handleChange(event){
        if(event.index==1){
            //this.getCustomers();
        }
    }
}
